import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../app/app.state';
import {AsideService} from '../../../../core/services/aside.service';
import {UrlService} from '../../../../core/services/url.service';

@Component({
    selector: 'motn-controls-child-base',
    template: ``,
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class ControlsChildBaseComponent implements OnInit, OnDestroy {

  protected constructor(
    protected store: Store<AppState>,
    protected asideService: AsideService,
    protected urlService: UrlService,
  ) {
  }

  ngOnInit(): void {
    this.updateTitle();
    // this.updateAside();

    this.onInit();
  }

  ngOnDestroy(): void {
    this.onDestroy();
  }

  protected abstract onInit(): void;

  protected abstract onDestroy(): void;

  // protected abstract updateAside(): void;

  protected abstract updateTitle(): void;
}
